exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "a{color:#3d81a1;text-decoration:none;-webkit-text-decoration-skip:ink!important;text-decoration-skip:ink!important}a:hover{text-decoration:underline}img:not([src]){opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"discardComments":{"removeAll":true}}!./src/components/global.css
// module id = 712
// module chunks = 0